import { render, staticRenderFns } from "./shaidan.vue?vue&type=template&id=2c7f4cab&scoped=true"
import script from "./shaidan.vue?vue&type=script&lang=js"
export * from "./shaidan.vue?vue&type=script&lang=js"
import style0 from "./shaidan.vue?vue&type=style&index=0&id=2c7f4cab&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c7f4cab",
  null
  
)

export default component.exports